import { defineMessages } from 'react-intl';

export default defineMessages({
    printQuote: {
        id: 'wmic.quoteandbind.directives.templates.QnbWizardButtons.Print this quote',
        defaultMessage: 'Print this quote',
    }
});
